var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "16.07 12.07 28.38 35.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.301,
    y: 12.4482,
    width: 21.3004,
    height: 31.1851,
    rx: 1.625,
    transform: "rotate(12.694 23.301 12.4482)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6143,
    y: 14.4074,
    width: 21.3004,
    height: 31.1851,
    rx: 1.625,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8228 33.0414H24.2729C23.9901 33.0414 23.8015 33.23 23.8015 33.5129C23.8015 33.7957 23.9901 33.9843 24.2729 33.9843H35.7756C36.0585 33.9843 36.2471 33.7957 36.2471 33.5129C36.2471 33.23 36.0585 33.0414 35.8228 33.0414Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8228 35.6343H24.2729C23.9901 35.6343 23.8015 35.8228 23.8015 36.1057C23.8015 36.3886 23.9901 36.5771 24.2729 36.5771H35.7756C36.0585 36.5771 36.2471 36.3886 36.2471 36.1057C36.2471 35.8228 36.0585 35.6343 35.8228 35.6343Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8228 38.2271H24.2729C23.9901 38.2271 23.8015 38.4157 23.8015 38.6985C23.8015 38.9814 23.9901 39.1699 24.2729 39.1699H35.7756C36.0585 39.1699 36.2471 38.9814 36.2471 38.6985C36.2471 38.4157 36.0585 38.2271 35.8228 38.2271Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.677 40.645H24.0319C23.8936 40.645 23.8015 40.7971 23.8015 41.0252C23.8015 41.2533 23.8936 41.4054 24.0319 41.4054H29.654C29.7922 41.4054 29.8844 41.2533 29.8844 41.0252C29.8844 40.7971 29.7922 40.645 29.677 40.645Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4476 21.7889H33.0965V19.4378C33.0965 19.1135 32.8263 18.8432 32.502 18.8432H28.6645C28.3402 18.8432 28.07 19.1135 28.07 19.4378V21.7889H25.7189C25.3946 21.7889 25.1243 22.0591 25.1243 22.3834V26.2209C25.1243 26.5452 25.3946 26.8154 25.7189 26.8154H28.07V29.1665C28.07 29.4908 28.3402 29.7611 28.6645 29.7611H32.502C32.8263 29.7611 33.0965 29.4908 33.0965 29.1665V26.8154H35.4476C35.7719 26.8154 36.0421 26.5452 36.0421 26.2209V22.3834C36.0421 22.0321 35.7719 21.7889 35.4476 21.7889ZM34.8801 25.6263H32.529C32.2047 25.6263 31.9345 25.8966 31.9345 26.2209V28.572H29.259V26.2209C29.259 25.8966 28.9888 25.6263 28.6645 25.6263H26.3134V22.9509H28.6645C28.9888 22.9509 29.259 22.6807 29.259 22.3564V20.0053H31.9345V22.3564C31.9345 22.6807 32.2047 22.9509 32.529 22.9509H34.8801V25.6263Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8802 25.6263H32.5291C32.2048 25.6263 31.9346 25.8966 31.9346 26.2209V28.572H29.2592V26.2209C29.2592 25.8966 28.9889 25.6263 28.6646 25.6263H26.3135V22.9509H28.6646C28.9889 22.9509 29.2592 22.6807 29.2592 22.3564V20.0053H31.9346V22.3564C31.9346 22.6807 32.2048 22.9509 32.5291 22.9509H34.8802V25.6263Z",
    fill: "#F2B543"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.8f3db18dacccf861abf9bf1b2ea9a545.svg";
export { ForwardRef as ReactComponent };